module.exports = __webpack_public_path__ + "static/media/icon5_roll.95d5412e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Homepage/icon5_roll.png
// module id = 351
// module chunks = 0